import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'

// Module Imports
import pashadowing from './modules/pashadowing'
import mygrades from './modules/mygrades'
import services from './modules/services'
import evaluations from  './modules/evaluations'
import exams from './modules/exams'
import healthcareexperience from './modules/healthcareexperience'

Vue.use(Vuex)

export const store = new Vuex.Store ({
  state: {
    loadedSchools: [],
    loadedCourses: [],
    customCourses: [],
    faqCategories: null,
    user:null,
    savedSchools: [],
    loading: false,
    error: null,
    token: null,

  },

  mutations: {
  // Set Schools to store
  setLoadedSchools(state, payload) {
    state.loadedSchools = payload
  },
  // Set Coures to store
  setLoadedCourses(state, payload) {
    state.loadedCourses = payload
  } ,
  // Sets user to store
  setUser (state, payload) {
    state.user = payload
    state.savedSchools = []
  },
  // Login User Info
  setLoginUser(state, payload) {
    state.userColleges = payload
  },
  // Logout User
  setLogoutUser(state, payload = null) {
    state.user = payload
    state.savedSchools = []

  },


   ////////// Loading Status
  setLoading (state, payload) {
    state.loading = payload
  },
  // Errors
  setError (state, payload) {
    state.error = payload
  },
  // Clear Error
  clearError (state) {
    state.error = null
  },

  // Load Saved Schools on Login
  setSavedSchools(state, payload) {
    payload.forEach((savedSchool)=> state.loadedSchools.forEach((school)=> {
      if(savedSchool.id === school.id) {
        state.savedSchools.push(school)
      }
    }
  ))

  },
  savedSchoolStatus(state, payload) {
   state.savedSchools.forEach(savedSchool => {
    if(savedSchool.id === payload.savedSchoolId) {

    }
   })

  },
  // Add Saved Schools
  addSavedSchool(state, payload) {
    state.savedSchools.push(payload)
  },
  // Remove Saved School
  removeSavedSchool(state, payload) {
    state.savedSchools.forEach((savedSchool)=> {
      if(savedSchool.id === payload) {
        state.savedSchools.splice(state.savedSchools.indexOf(savedSchool), 1)
      }
    })
  },

  setFAQCategories (state, payload = null) {
    Vue.set(state, 'faqCategories', payload)
    return state
  }
  },

  actions: {
    // Load Schools from database
    loadSchools({commit}) {
      firebase.database().ref('schools').once('value')
      .then((data) => {
        const schools = []
        const obj = data.val()
        for(let key in obj) {
          schools.push({...obj[key], id:key})
        }
        commit('setLoadedSchools', schools)
      })
      .catch(
        (error) => {
          console.log(error)
        }
      )
    },
    // Load Courses from database
    loadCourses({commit}) {
      firebase.database().ref('courses').once('value')
      .then((data) => {
        const courses = []
        const obj = data.val()
        for(let key in obj) {
          courses.push({...obj[key], id:key})
        }
        commit('setLoadedCourses', courses)
      })
      .catch(
        (error) => {
          console.log(error)
        }
      )
    },
    // Authenticate User
    async signUserUp({commit, getters}, { email, password, name, agreement, user_profile, aapa_member_id }) {
      // Sets Loading Mutation to true
      commit('setLoading', true)
      // Clears any Errors before reaching to firebase
      commit('clearError')
      // Create user account
      try {
        const createdUser = await firebase.auth().createUserWithEmailAndPassword( email, password )
        const userRef = firebase.database().ref(`users/${createdUser.user.uid}`)
        await userRef.update({ name, email, agreement, user_profile, aapa_member_id })
        const newUser = await userRef.once('value')
        commit('setUser', { ...createdUser.user, ...newUser.val() })
      } catch (error) {
        commit('setError', error)
        console.log(error)
      } finally {
        commit('setLoading', false)
      }

      // .then(
      //   cred => {

      //     const uid = cred.user.uid
      //     console.log(cred)
      //     // const newUser = {
      //     //   name: payload.name,
      //     //   id: uid,
      //     //   sources: [{
      //     //     ...payload.token
      //     //   }]
      //     // }



      //     // firebase.database().ref('users').child(uid).set(newUser)

      //     // .then((data) => {
      //     //   firebase.database().ref(`/users/${getters.user.id}/stripe_customer_id`).on('value', snapshot => {
      //     //     if (snapshot.val()) {
      //     //       firebase.database().ref(`/users/${getters.user.id}/charges`).push({amount: payload.amount, token: payload.token})
      //     //     } else {
      //     //       throw new Error('couldnnot create stripe user')
      //     //     }
      //     //   }, () => {

      //     //   });
      //     // })
      //     // .catch((error) => {
      //     //   console.log(error)
      //     //   })
      //   },
      // )
      // .catch(
      //   error => {
      //     commit('setLoading', false)
      //     commit('setError', error)
      //     console.log(error)

      //   }
      // ).finally(() )
    },
    async setupUserData ({ commit }, cred) {
      const uid = cred.uid
      const data = await firebase.database().ref('/users/' + uid).once('value')
      // const key = data.key
      const obj = data.val()
      const loginUser = {
        id: uid,
        ...cred,
        ...obj
      }

      if (!obj) {
        return commit('setUser', loginUser)
      }
      // User Saved Colleges
      const userColleges = []
      for (const key in obj.colleges) {
      userColleges.push({...obj.colleges[key], id:key})
      }
      for(var i=0; i < userColleges.length; i++) {
        const apcourses = []
        for (const key in userColleges[i].apcourses) {
          apcourses.push({...userColleges[i].apcourses[key], id:key, })
        }
        userColleges[i].apcourses = apcourses
      }

      for(var i=0; i < userColleges.length; i++) {
        const clepcourses = []
        for (const key in userColleges[i].clepcourses) {
          clepcourses.push({...userColleges[i].clepcourses[key], id:key, })
        }
        userColleges[i].clepcourses = clepcourses
      }
      // Convert Semester Array and Courses Array
      for(var i=0; i < userColleges.length; i++) {
        const semester = []
        for (const key in userColleges[i].semesters) {
          semester.push({...userColleges[i].semesters[key], id:key, })
        }
        userColleges[i].semesters = semester

        // Add Courses Array
        for(var c=0; c <userColleges[i].semesters.length; c++) {
          const course = []
          for (const key in userColleges[i].semesters[c].courses) {
            course.push({...userColleges[i].semesters[c].courses[key], id:key, })
          }
          userColleges[i].semesters[c].courses = course
        }
      }


      // User Saved Schools
      const savedSchools = []
      for (const key in obj.saved_schools) {
        savedSchools.push({...obj.saved_schools[key], id:key})
      }

      // User PA Shadowing
      const paShadowing = []
      for (const key in obj.pa_shadowing) {
        paShadowing.push({...obj.pa_shadowing[key], id:key})
      }

      // Add PA Shadowing Logged Hours Array
      for(var i=0; i < paShadowing.length; i++) {
        const loggedHours= []
        for (const key in paShadowing[i].logged_hours) {
          loggedHours.push({...paShadowing[i].logged_hours[key], id:key, })
        }
        paShadowing[i].logged_hours = loggedHours

      }

      // User Saved Evaluations
      const evaluations = []
      for(const key in obj.evaluations) {
        evaluations.push({...obj.evaluations[key], id:key})
      }

      // Direct Paid Patient Experience
      const directPaidHours = []
      for(const key in obj.direct_paid_patient_experience) {
        directPaidHours.push({...obj.direct_paid_patient_experience[key], id: key})
      }

      // Add Direct Paid Logged Hours Array
      for(var i=0; i < directPaidHours.length; i++) {
        const loggedDirectPaidHours= []
        for (const key in directPaidHours[i].logged_hours) {
          loggedDirectPaidHours.push({...directPaidHours[i].logged_hours[key], id:key, })
        }
        directPaidHours[i].logged_hours = loggedDirectPaidHours
      }

      // Direct Patient Experience
      const directHours = []
      for(const key in obj.direct_patient_experience) {
        directHours.push({...obj.direct_patient_experience[key], id:key})
      }

      // Add Direct Patient Logged Hours Array
      for(var i=0; i < directHours.length; i++) {
        const loggedDirectHours= []
        for (const key in directHours[i].logged_hours) {
          loggedDirectHours.push({...directHours[i].logged_hours[key], id:key, })
        }
        directHours[i].logged_hours = loggedDirectHours
      }

      // Indirect Patient Experience
      const indirectHours = []
      for(const key in obj.indirect_patient_experience) {
        indirectHours.push({...obj.indirect_patient_experience[key], id:key})
      }

      // Add Indirect Patient Logged Hours Array
      for(var i=0; i < indirectHours.length; i++) {
        const loggedIndirectHours= []
        for (const key in indirectHours[i].logged_hours) {
          loggedIndirectHours.push({...indirectHours[i].logged_hours[key], id:key, })
        }
        indirectHours[i].logged_hours = loggedIndirectHours
      }

      // Volunteer Experience
      const volunteerHours = []
      for(const key in obj.volunteer_experience) {
        volunteerHours.push({...obj.volunteer_experience[key], id:key})
      }

      // Add Volunteer Experience Logged Hours Array
      for(var i=0; i < volunteerHours.length; i++) {
        const loggedVolunteerHours= []
        for (const key in volunteerHours[i].logged_hours) {
          loggedVolunteerHours.push({...volunteerHours[i].logged_hours[key], id:key, })
        }
        volunteerHours[i].logged_hours = loggedVolunteerHours
      }

      // Community Service
      const communityServiceHours = []
      for(const key in obj.community_service_experience) {
        communityServiceHours.push({...obj.community_service_experience[key], id:key})
      }

       // Add Volunteer Experience Logged Hours Array
       for(var i=0; i < communityServiceHours.length; i++) {
        const loggedCommunityServiceHours= []
        for (const key in communityServiceHours[i].logged_hours) {
          loggedCommunityServiceHours.push({...communityServiceHours[i].logged_hours[key], id:key, })
        }
        communityServiceHours[i].logged_hours = loggedCommunityServiceHours
      }

      // User Exams
      const userExams = []
      for(const key in obj.exams) {
        userExams.push({...obj.exams[key], id:key})
      }

      // User Certifications
      const userCertifications = []
      for(const key in obj.certifications) {
        userCertifications.push({...obj.certifications[key], id:key})
      }


      commit('setUser', loginUser)
      commit('loadUserColleges', userColleges)
      commit('setSavedSchools', savedSchools)
      commit('setUserEvaluations', evaluations)
      commit('setPaShadowingHours', paShadowing)
      commit('setdirectPaidHours', directPaidHours)
      commit('setdirectHours', directHours)
      commit('setindirectHours', indirectHours)
      commit('setvolunteerHours', volunteerHours)
      commit('setcommunityServiceHours', communityServiceHours)
      commit('setUserExams', userExams)
      commit('setUserCertification', userCertifications)
    },
    // Log User In
    async loginUser({commit, dispatch}, payload) {
      // Sets Loading Mutation to true
      commit('setLoading', true)
      // Clears any Errors before reaching to firebase
      commit('clearError')
      try {
        await firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        // Login removed here as user sesstion is handled by authChange callback at root
      } catch (error) {
        commit('setLoading', false)
        commit('setError', error)
        console.log(error)
      }
    },
    // Logout User
    logout({commit}, payload = null) {
      commit('setLogoutUser', payload)
    },
    async fetchFAQCategories ({ commit }) {
      const snapshot = await firebase.firestore().collection('SchoolFaqCategories').get()
      if (!snapshot.empty) {
        commit('setFAQCategories', snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })))
      }
    },
    async saveUserProfile ({ commit, dispatch, getters }, payload = null) {
      await firebase.database().ref('/users/' + getters.user.uid + '/user_profile').set(payload)
      dispatch('setupUserData', firebase.auth().currentUser)
    },
    // Save School
    setSaveSchool({commit, getters}, payload) {

      firebase.database().ref('/users/' + getters.user.uid + '/saved_schools').child(payload.id).set( {id :payload.id})
      .then(() => {
        commit('addSavedSchool', payload)
        return
      })
    },
    setSavedSchoolStatus({commit}, payload) {
      commit('savedSchoolStatus', payload)
    },

    // Set Remove Saved School
    setRemoveSavedSchool({commit, getters}, payload) {
      firebase.database().ref('/users/' + getters.user.uid + '/saved_schools/').child(payload).remove()
      .then((data) => {
        commit('removeSavedSchool', payload)
      })
    },


    // Get User data from FB
    fetchUserData ({commit, getters}) {
      commit('setLoading', true)
      // firebase.database().ref('/users/' + getters.user.id + '')
    },
    // Auto Sign In User
    async autoSignIn({ commit, dispatch }, payload) {
      commit('setLoading', true)
      const user = await dispatch('setupUserData', payload)
      // commit('setUser', user)
      commit('setLoading', false)
    },
    // Action to clear error
    clearError({commit}, payload) {
      commit('clearError')
    },

    // STRIPE RELATED ACTIONS
    async addStripePaymentSource ({ commit, getters }, { token }) {
      if (!getters.user) return commit('logout')
      if (!token) throw new Error('Payment token missing')
      const createPaymentSource = firebase.functions().httpsCallable('createPaymentSource')
      try {
        const tokenRef = await createPaymentSource({ token })
        return tokenRef
      } catch (error) {
        throw error
      }
    },

    async addStripeSubscription ({ commit, getters, dispatch }, { couponCode = null }) {
      if (!getters.user) return commit('logout')
      const createSubsciption = firebase.functions().httpsCallable('createSubsciption')
      try {
        const subs = await createSubsciption({ type: 'stripe', couponCode })
        dispatch('setupUserData', firebase.auth().currentUser)
        return subs
      } catch (error) {
        throw error
      }
      // const stripeSourceRef = firebase.database().ref(`stripe_customers/${getters.user.uid}/subscriptions`).push()
      // create null sunscription
      // await stripeSourceRef.set({ subscribe_request: true })
    },

    async forgotPasswordEmail ({ commit, getters }, { email }) {
      try {
        const data = await firebase.auth().sendPasswordResetEmail(email, { url: location.href })
        return data
      } catch (error) {
        throw error
      }
    },
    async upsertSchoolAppStatus({ dispatch, getters }, status) {
      await firebase.database().ref('/users/' + getters.user.uid + '/school_applications/' + status.id).set(status)
      dispatch('setupUserData', firebase.auth().currentUser)
    },
    async saveCustomCourse ({ dispatch, getters }, payload) {
      const data = await firebase.database().ref('/users/' + getters.user.uid + '/custom_courses/').push(payload)
      dispatch('setupUserData', firebase.auth().currentUser)
      return data.key
    },
    async saveSchoolOveride ({ dispatch, getters }, payload) {
      if (!payload.schoolId) throw new Error('schoolId Missing')
      await firebase.database().ref('/users/' + getters.user.uid + '/school_overides/' + payload.schoolId).push(payload)
      dispatch('setupUserData', firebase.auth().currentUser)
    },
    async removeSchoolOveride ({ dispatch, getters }, payload) {
      if (!payload.schoolId || !payload.id) throw new Error('ID Missing')
      await firebase.database().ref('/users/' + getters.user.uid + '/school_overides/' + payload.schoolId + '/' + payload.id).remove()
      dispatch('setupUserData', firebase.auth().currentUser)
    }
  },

  getters: {
    // List of all schools
    loadedSchools(state) {
      return state.loadedSchools.sort((schoolA, schoolB) => {
        if(schoolA.school_name < schoolB.school_name) {
         return -1;
        }
        if(schoolA.school_name > schoolB.school_name) {
          return 1;
        }
     })
    },
    // List of courses
    loadedCourses(state) {
      return state.loadedCourses.sort((courseA, courseB) => {
        if(courseA.course_name < courseB.course_name) {
         return -1;
        }
        if(courseA.course_name > courseB.course_name) {
          return 1;
        }
     })

    },
    // Number of total school
    totalSchools(state) {
      return state.loadedSchools.length
    },
    // Get Indiviual School Detail
    loadedSchool(state) {
      return (id) => {
        return state.loadedSchools.find((school) => {
          return school.id === id
        })
      }
    },

    validSubscription (state) {
      if (!state.user || !state.user.subscriptions) return false
      const subscriptions = Object.values(state.user.subscriptions)
      return subscriptions.reduce((activeSub, subscription) => {
        if (activeSub) return activeSub
        if (subscription.kind == 'stripe') {
          if (!subscription.subscription) return null
          const { current_period_end, current_period_start } =  subscription.subscription
          if (current_period_end > current_period_start) return subscription
          return null
        }
        return null
      }, null)
    },

    // Return Logged in User
    user(state) {
      return state.user
    },


    NumberOfuserSavedSchools(state) {
      // return state.user.savedSchools.length
    },
    // Loading State
    loading (state) {
      return state.loading
    },
    // Return error
    error(state) {
      return state.error
    },
    // Saved Schools
    savedSchools(state) {

      return state.savedSchools.sort((courseA, courseB) => {
        if(courseA.school_name < courseB.school_name) {
         return -1;
        }
        if(courseA.school_name > courseB.school_name) {
          return 1;
        }
     })


    },

    userSchoolApplications (state) {
      if (!state.user || !state.user.school_applications) return []
      return Object.entries(state.user.school_applications).map(([id, value = {}]) => {
        return {
          id,
          ...value
        }
      })
    },

    userCustomCourses (state) {
      if (!state.user || !state.user.custom_courses) return []
      return Object.entries(state.user.custom_courses).map(([id, value = {}]) => {
        return {
          id,
          ...value
        }
      })
    },

    userSchoolOverides (state) {
      if (!state.user || !state.user.school_overides) return []
      return state.user.school_overides
    },

    // Saved School Info
    savedSchoolInfo(state) {
      return (id) => {
        return state.savedSchools.find((savedSchool) => {
          return savedSchool.id === id
        })
      }
    },

  },

  modules : {
    pashadowing,
    mygrades,
    evaluations,
    exams,
    healthcareexperience,
    services
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js